import { APP_NAME } from '../common';

// Adapted from https://oppgit.eficode.com/projects/INSNLC/repos/vakklso002-my-insurances/browse/myinsurance-front/js/src/hooks/useSessionStorage.ts

interface SessionStorage {
  getItem: (key: string) => string | null;
  updateItem: (key: string, value: string | null) => void;
}

/**
 * Hook providing simple abstraction of `SessionStorage`
 * - Fallbacks to no-op session storage in environments where actual implementation is unavailable
 */
export function useSessionStorage(): SessionStorage {
  return getSessionStorage();
}

function getSessionStorage(): SessionStorage {
  const actual = window.sessionStorage;

  if (!actual) return NoopSessionStorage;

  const getItemName = (key: string) => `${APP_NAME}-${key}`;

  const getItem = (key: string) => actual.getItem(getItemName(key));

  const updateItem = (key: string, value: string | null | undefined) => {
    if (value) {
      actual.setItem(getItemName(key), value);
    } else {
      actual.removeItem(getItemName(key));
    }
  };

  return { getItem, updateItem };
}

const NoopSessionStorage = {
  getItem: () => null,
  updateItem: () => undefined,
};
